import React, { createContext, useState, useEffect, useContext } from 'react';


const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Пытаемся восстановить состояние пользователя из localStorage
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [loading, setLoading] = useState(true);

  const fetchUserData = async () => {
    console.log("fetchUserData called");
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/get`, {
        headers: {
          "Access-Control-Allow-Origin": `${process.env.REACT_APP_API_URL}`,
        },
        credentials: "include",

      });

      if (response.status === 401) {
        setUser(null);
        localStorage.removeItem('user');
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch user data.");
      }

      const data = await response.json();
      setUser(data);
      // Сохраняем данные пользователя в localStorage
      localStorage.setItem('user', JSON.stringify(data));
    } catch (error) {
      console.error("Error fetching user data:", error);
      setUser(null);
      localStorage.removeItem('user');
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchUserData();
  }, []);


  return (
    <UserContext.Provider value={{ user, setUser, fetchUserData, loading }}>
      {children}
    </UserContext.Provider>
  );
};

